<template>
  <base-popup
    class="payouts-registry-item-delete-popup payouts-registry-item-delete-popup--delete"
    ref="popup"
  >
    <template #icon>
      <svg
        width="8"
        height="36"
        viewBox="0 0 8 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.99902 30.0039C5.10359 30.0039 5.99902 30.8993 5.99902 32.0039L5.99902 33.0039C5.99902 34.1085 5.10359 35.0039 3.99902 35.0039C2.89445 35.0039 1.99902 34.1085 1.99902 33.0039L1.99902 32.0039C1.99902 30.8993 2.89445 30.0039 3.99902 30.0039Z"
          fill="#F2F2F2"
        />
        <path
          d="M0.510912 3.97101C0.239473 1.86737 1.87794 0.00390625 3.99903 0.00390625C6.12012 0.00390625 7.75858 1.86737 7.48714 3.97102L4.9908 23.3176C4.84078 24.4803 3.15728 24.4803 3.00725 23.3176L0.510912 3.97101Z"
          fill="#F2F2F2"
        />
      </svg>
    </template>
    <template #content>
      {{ $t('payouts.by-registry.created.popup.delete.text') }}
    </template>
    <template #actions="{ confirm, close }">
      <div class="payouts-registry-item-delete-popup__actions">
        <primary-button
          class="payouts-registry-item-delete-popup__actions-item"
          @click="confirm(true)"
          :label="
            $t('payouts.by-registry.created.popup.delete.actions.confirm')
          "
        ></primary-button>
        <no-bg-button
          class="payouts-registry-item-delete-popup__actions-item"
          @click="close"
          :label="$t('payouts.by-registry.created.popup.delete.actions.cancel')"
        ></no-bg-button>
      </div>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
export default {
  name: 'PayoutsRegistryItemDeletePopup',
  components: { NoBgButton, PrimaryButton, BasePopup },
  methods: {
    open() {
      return this.$refs.popup.open()
    },
  },
}
</script>

<style lang="scss" scoped>
.payouts-registry-item-delete-popup {
  &--delete & {
    &__actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-item {
        padding: 13px 35px;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
